import { ChangeDetectionStrategy, Component, HostBinding, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeType } from './badge.constants';
import {IconsComponent} from '@sml/icons';

const baseClass = 'tw-inline-flex tw-items-center tw-justify-center tw-text-xs tw-leading-4 tw-py-1.5 tw-px-2.5 tw-font-bold tw-border-[1px] tw-rounded-full';
const themeClasses: Record<BadgeType, string> = {
  orange: 'badge-orange tw-text-warning-600 tw-border-warning-600 tw-bg-warning-600 tw-bg-opacity-10',
  green: 'badge-green tw-text-success-600 tw-border-success-600 tw-bg-success-600 tw-bg-opacity-10',
  blue: 'badge-blue tw-text-primary-700 tw-border-primary-700 tw-bg-primary-700 tw-bg-opacity-10',
  grey: 'badge-grey tw-text-grey-750 tw-border-grey-750 tw-bg-grey-750 tw-bg-opacity-10',
  mercury:'badge-grey tw-text-grey-750 tw-border-mercury-600 tw-bg-surface-100 ',
  red:'badge-red tw-text-[#D11A2A] tw-border-[#D11A2A] tw-bg-[#D11A2A] tw-bg-opacity-10',
  lightgreen:'badge-green tw-text-[#5E8E48] tw-border-[#5E8E48] tw-bg-surface-100 '
}
const buildTwClasses = (theme: BadgeType) => {
  return `${baseClass} ${themeClasses[theme]}`;
}
const themeIconClasses: Record<BadgeType, string> = {
  orange: 'tw-bg-warning-600',
  green: 'tw-bg-success-600',
  blue: 'tw-bg-primary-700',
  grey: 'tw-bg-grey-750',
  mercury:'tw-bg-grey-750',
  red:'tw-bg-[#D11A2A]',
  lightgreen:'tw-bg-[#5E8E48]'
}

@Component({
  selector: 'sml-badge',
  imports: [CommonModule, IconsComponent],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  @Input() label = 'Label';
  @Input() showIcon = true;
  @Input () textSizeClass =''
  @Input() useBorder = false;
  @Input() isCalledFromStory = false;
  @Input() textColor = '';
  @Input() iconName='';
  @Input() storyDesign = false;
  prefix = input<string>('');
  postfix = input<string>('');

  @Input() set type(value: BadgeType) {
    this._theme = value;
    this.twClasses = buildTwClasses(value);
  }
  @HostBinding('class') private twClasses = buildTwClasses('orange');
  private _theme: BadgeType = 'orange';
 @HostBinding('class') get hostClasses(): string {
  if (this.useBorder && this.label=='Completed') {
    return `${baseClass} !tw-text-[#106B8E] tw-bg-transparent !tw-border-0`;

  }
  else if(this.useBorder && this.label!='Completed'){
    return `${baseClass} !tw-text-[#5E8E48] !tw-bg-transparent !tw-border-0`;
  }
  return this.twClasses;
}

  get iconClasses(): string {
    if(this.useBorder && this.label=='Completed'){
      return `badge-icon ${themeIconClasses.blue}`;
    }
    if(this.useBorder && this.label!='Completed'){
      return `badge-icon ${themeIconClasses.green}`;
    }
    return `badge-icon ${themeIconClasses[this._theme]}`;
  }
}
